var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"social-icons-all"},[_c('vue-yandex-share',_vm._b({},'vue-yandex-share',_vm.options,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }